// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animation-close {
  font-size: 1.2em;
}

.animation-close__outer {
  cursor: pointer;
  width: 33px;
  margin-top: 0;
  position: relative;
  overflow: hidden;
}

.animation-close__inner {
  width: inherit;
  text-align: center;
}

.animation-close__label {
  text-transform: uppercase;
  color: var(--text-color);
  opacity: 0;
  cursor: pointer;
  margin-top: 3px;
  font-size: .8em;
  font-weight: normal;
  line-height: 2em;
  transition: all .3s ease-in;
}

.animation-close__inner:before, .animation-close__inner:after {
  content: "";
  height: 1px;
  width: inherit;
  background: var(--text-color);
  transition: all .3s ease-in;
  position: absolute;
  left: 0;
}

.animation-close__inner:before {
  top: 50%;
  transform: rotate(45deg);
}

.animation-close__inner:after {
  bottom: 50%;
  transform: rotate(-45deg);
}

.animation-close__outer:hover .animation-close__label {
  opacity: 1;
}

.animation-close__outer:hover .animation-close__inner:before, .animation-close__outer:hover .animation-close__inner:after {
  transform: rotate(0);
}

.animation-close__outer:hover .animation-close__inner:before {
  top: 0;
}

.animation-close__outer:hover .animation-close__inner:after {
  bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/AnimationClose/styles/AnimationClose.css","webpack://./services/frontend/app/components/AnimationClose/styles/AnimationClose.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,UAAU;EACV,eAAe;EACf,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX","sourcesContent":[".animation-close {\n  font-size: 1.2em;\n}\n\n  .animation-close__outer {\n    position: relative;\n    width: 33px;\n    margin-top: 0;\n    cursor: pointer;\n    overflow: hidden;\n  }\n\n  .animation-close__inner {\n    width: inherit;\n    text-align: center;\n    /*   overflow: hidden; */\n  }\n\n  .animation-close__label {\n    font-size: 0.8em;\n    line-height: 2em;\n    text-transform: uppercase;\n    color: var(--text-color);\n    transition: all 0.3s ease-in;\n    opacity: 0;\n    cursor: pointer;\n    font-weight: normal;\n    margin-top: 3px;\n  }\n\n  .animation-close__inner:before,\n  .animation-close__inner:after {\n    position: absolute;\n    content: '';\n    height: 1px;\n    width: inherit;\n    background: var(--text-color);\n    left: 0;\n    transition: all 0.3s ease-in;\n  }\n\n  .animation-close__inner:before {\n    top: 50%;\n    transform: rotate(45deg);\n  }\n\n  .animation-close__inner:after {\n    bottom: 50%;\n    transform: rotate(-45deg);\n  }\n\n  .animation-close__outer:hover .animation-close__label {\n    opacity: 1;\n  }\n\n  .animation-close__outer:hover .animation-close__inner:before,\n  .animation-close__outer:hover .animation-close__inner:after {\n    transform: rotate(0);\n  }\n\n  .animation-close__outer:hover .animation-close__inner:before {\n    top: 0;\n  }\n\n  .animation-close__outer:hover .animation-close__inner:after {\n    bottom: 0;\n  }\n",".animation-close {\n  font-size: 1.2em;\n}\n\n.animation-close__outer {\n  cursor: pointer;\n  width: 33px;\n  margin-top: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.animation-close__inner {\n  width: inherit;\n  text-align: center;\n}\n\n.animation-close__label {\n  text-transform: uppercase;\n  color: var(--text-color);\n  opacity: 0;\n  cursor: pointer;\n  margin-top: 3px;\n  font-size: .8em;\n  font-weight: normal;\n  line-height: 2em;\n  transition: all .3s ease-in;\n}\n\n.animation-close__inner:before, .animation-close__inner:after {\n  content: \"\";\n  height: 1px;\n  width: inherit;\n  background: var(--text-color);\n  transition: all .3s ease-in;\n  position: absolute;\n  left: 0;\n}\n\n.animation-close__inner:before {\n  top: 50%;\n  transform: rotate(45deg);\n}\n\n.animation-close__inner:after {\n  bottom: 50%;\n  transform: rotate(-45deg);\n}\n\n.animation-close__outer:hover .animation-close__label {\n  opacity: 1;\n}\n\n.animation-close__outer:hover .animation-close__inner:before, .animation-close__outer:hover .animation-close__inner:after {\n  transform: rotate(0);\n}\n\n.animation-close__outer:hover .animation-close__inner:before {\n  top: 0;\n}\n\n.animation-close__outer:hover .animation-close__inner:after {\n  bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
